import { useContext, useEffect, useState } from "react";
import { HttpContext } from "../HttpContext";

export function useFlService(subjectId, type) {
  const { httpClient } = useContext(HttpContext);
  const [flSubject, setFlSubject] = useState({});

  useEffect(() => {
    if (!isNaN(parseInt(subjectId)) && type === "fl") {
      getFlSubject(subjectId).then(data => setFlSubject(data))
    }
  }, [subjectId, type])

  const getFlSubjects = async () => {
    return httpClient.get("/flsubject/all").then(promise => promise.data)
  }

  const getFlSubjectsPage = async (page, pageSize) => {
    return httpClient.get(`/flsubject/all?page=${page}&pageSize=${pageSize}`).then(promise => promise.data)
  }

  const getFlSubject = async (id) => {
    return httpClient.get(`/flsubject/${id}`).then(promise => promise.data)
  }

  const deleteFlSubject = async (id) => {
    return httpClient.delete(`/flsubject/${id}`)
  }

  const updateFlSubject = async (body) => {
    return httpClient.put("/flsubject", body).then(promise => promise.data)
  }

  const createFlSubject = async (body) => {
    return httpClient.post("/flsubject", body).then(promise => promise.data)
  }

  return { getFlSubjects, getFlSubject, updateFlSubject, deleteFlSubject, createFlSubject, getFlSubjectsPage, flSubject, setFlSubject }
}